/**
 * Commission catalog fixtures aligned with pga-backend graphql-schemas/backoffice.graphql.
 * Fields and enum values mirror BackofficeCommissionProgram, Partner, Campaign, and Enrollment.
 */
import type { CommissionCampaignNode } from "../campaigns/types";
import type { CommissionEnrollmentNode } from "../enrollments/types";
import type { CommissionPartnerNode } from "../partners/types";
import type { CommissionProgramNode } from "../programs/types";

export const commissionProgramFixtures: CommissionProgramNode[] = [
  {
    id: "commission-program-grp",
    name: "Golf Retirement Plus",
    slug: "grp",
    status: "ACTIVE"
  },
  {
    id: "commission-program-legacy",
    name: "Legacy Sponsor Incentive",
    slug: "legacy-sponsor-incentive",
    status: "ARCHIVED"
  }
];

export const commissionPartnerFixtures: CommissionPartnerNode[] = [
  {
    id: "commission-partner-acme",
    name: "Acme Golf Sponsors",
    legacyId: "SP-1042",
    status: "ACTIVE"
  },
  {
    id: "commission-partner-fairway",
    name: "Fairway Financial Group",
    legacyId: "SP-2088",
    status: "ACTIVE"
  },
  {
    id: "commission-partner-retired",
    name: "Sunset Equipment Co.",
    legacyId: "SP-0199",
    status: "INACTIVE"
  }
];

const grpProgramSummary = {
  id: "commission-program-grp",
  name: "Golf Retirement Plus",
  slug: "grp"
};

export const commissionCampaignFixtures: CommissionCampaignNode[] = [
  {
    id: "commission-campaign-2026-acme",
    editionYear: 2026,
    status: "ACTIVE",
    payoutCadence: "QUARTERLY",
    startsAt: "2026-01-01T00:00:00Z",
    endsAt: "2026-12-31T23:59:59Z",
    partner: { id: "commission-partner-acme", name: "Acme Golf Sponsors" },
    program: grpProgramSummary
  },
  {
    id: "commission-campaign-2026-fairway",
    editionYear: 2026,
    status: "DRAFT",
    payoutCadence: "QUARTERLY",
    startsAt: "2026-04-01T00:00:00Z",
    endsAt: "2027-03-31T23:59:59Z",
    partner: { id: "commission-partner-fairway", name: "Fairway Financial Group" },
    program: grpProgramSummary
  },
  {
    id: "commission-campaign-2025-acme",
    editionYear: 2025,
    status: "CLOSED",
    payoutCadence: "QUARTERLY",
    startsAt: "2025-01-01T00:00:00Z",
    endsAt: "2025-12-31T23:59:59Z",
    partner: { id: "commission-partner-acme", name: "Acme Golf Sponsors" },
    program: grpProgramSummary
  }
];

export const commissionEnrollmentFixtures: CommissionEnrollmentNode[] = [
  {
    id: "commission-enrollment-ada",
    accountStatus: "ACTIVE",
    person: {
      id: "person-ada",
      displayName: "Ada Lovelace",
      pgaId: "12345678"
    },
    program: grpProgramSummary
  },
  {
    id: "commission-enrollment-bobby",
    accountStatus: "ACTIVE",
    person: {
      id: "person-bobby",
      displayName: "Bobby Jones",
      pgaId: "87654321"
    },
    program: grpProgramSummary
  },
  {
    id: "commission-enrollment-removed",
    accountStatus: "REMOVED",
    person: {
      id: "person-casey",
      displayName: "Casey Martin",
      pgaId: "11223344"
    },
    program: grpProgramSummary
  }
];
